<!-- Controls -->
<div class="flex flex-wrap items-end gap-3 bg-white rounded-lg border border-gray-200 p-3 mb-4">
  <div class="w-36">
    <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">Show</label>
    <app-select-input [options]="levelOptions" [(ngModel)]="level" (ngModelChange)="reload(true)"></app-select-input>
  </div>
  <div class="w-40">
    <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">CTA</label>
    <app-select-input [options]="ctaOptions" [(ngModel)]="cta" (ngModelChange)="reload(true)"></app-select-input>
  </div>
  <div class="w-44">
    <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">Sort by</label>
    <app-select-input [options]="sortOptions" [(ngModel)]="sort" (ngModelChange)="reload(true)"></app-select-input>
  </div>
  <div class="flex-1 min-w-48">
    <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">Search</label>
    <input type="text" [(ngModel)]="search" (keyup.enter)="reload(true)" placeholder="Ad, ad set or campaign name"
      class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500">
  </div>
  <button (click)="reload(true)" class="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-4 py-2 rounded-md">
    <i class="fas fa-search mr-1"></i> Search
  </button>
</div>

<div *ngIf="errorMessage" class="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 mb-4 text-sm">
  <i class="fas fa-exclamation-circle mr-1"></i> {{ errorMessage }}
</div>

<div *ngIf="loading" class="text-center text-gray-500 py-10">
  <i class="fas fa-spinner fa-spin mr-1"></i> Loading leaderboard...
</div>

<div *ngIf="!loading && report">
  <div *ngIf="report.items.length === 0" class="bg-white rounded-lg border border-gray-200 p-6 text-center text-gray-500 text-sm">
    No Meta ad spent or brought a lead in this period<ng-container *ngIf="search || cta"> for these filters</ng-container>.
  </div>

  <div *ngIf="report.items.length > 0" class="bg-white rounded-lg border border-gray-200 mb-4 overflow-x-auto">
    <table class="min-w-full text-sm">
      <thead class="bg-gray-50 text-xs text-gray-500 uppercase">
        <tr>
          <th class="text-left px-3 py-2">{{ report.level === 'campaign' ? 'Campaign' : report.level === 'adset' ? 'Ad set' : 'Ad' }}</th>
          <th class="text-left px-3 py-2">CTA</th>
          <th class="text-right px-3 py-2">Spend</th>
          <th class="text-right px-3 py-2">Leads</th>
          <th class="text-right px-3 py-2">Sign-ups</th>
          <th class="text-right px-3 py-2">Booked</th>
          <th class="text-right px-3 py-2">First pickups</th>
          <th class="text-right px-3 py-2">Revenue</th>
          <th class="text-right px-3 py-2">Cost / lead</th>
          <th class="text-right px-3 py-2">Cost / sign-up</th>
          <th class="text-right px-3 py-2">CAC</th>
          <th class="text-right px-3 py-2">Revenue ROAS</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of report.items" class="border-t border-gray-100 align-top">
          <td class="px-3 py-2 max-w-xs">
            <div class="text-gray-900 font-medium truncate" [title]="row.name || row.id">{{ row.name || row.id }}</div>
            <div class="text-xs text-gray-400 truncate" *ngIf="report.level !== 'campaign'">
              {{ row.campaignName || 'Unknown campaign' }}<ng-container *ngIf="report.level === 'ad' && row.adsetName"> › {{ row.adsetName }}</ng-container>
            </div>
          </td>
          <td class="px-3 py-2">
            <span class="text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap" [ngClass]="ctaBadge(row.cta).classes">{{ ctaBadge(row.cta).label }}</span>
          </td>
          <td class="px-3 py-2 text-right">{{ row.spend ? (row.spend | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right">{{ row.leads | number }}</td>
          <td class="px-3 py-2 text-right">{{ row.signUps | number }}</td>
          <td class="px-3 py-2 text-right">{{ row.bookedCustomers | number }}</td>
          <td class="px-3 py-2 text-right">{{ row.firstPickups | number }}</td>
          <td class="px-3 py-2 text-right text-green-700">{{ row.revenue | currency:'INR':'symbol':'1.0-0' }}</td>
          <td class="px-3 py-2 text-right">{{ row.costPerLead != null ? (row.costPerLead | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right">{{ row.costPerSignUp != null ? (row.costPerSignUp | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right font-semibold">{{ row.cac != null ? (row.cac | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right font-semibold">{{ row.revenueRoas != null ? (row.revenueRoas + '×') : '—' }}</td>
        </tr>
        <tr class="border-t-2 border-gray-200 bg-gray-50 font-semibold">
          <td class="px-3 py-2" colspan="2">All {{ report.totalCount }} matching</td>
          <td class="px-3 py-2 text-right">{{ report.totals.spend | currency:'INR':'symbol':'1.0-0' }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.leads | number }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.signUps | number }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.bookedCustomers | number }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.firstPickups | number }}</td>
          <td class="px-3 py-2 text-right text-green-700">{{ report.totals.revenue | currency:'INR':'symbol':'1.0-0' }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.costPerLead != null ? (report.totals.costPerLead | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.costPerSignUp != null ? (report.totals.costPerSignUp | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.cac != null ? (report.totals.cac | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
          <td class="px-3 py-2 text-right">{{ report.totals.revenueRoas != null ? (report.totals.revenueRoas + '×') : '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-pagination *ngIf="report.totalCount > 0"
    [page]="currentPage" [totalPages]="totalPages" [pageSize]="pageSize"
    (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
  </app-pagination>

  <p class="text-xs text-gray-400 leading-relaxed mt-2">
    Spend is Meta's daily spend for the selected dates. Leads are people whose first touch was this ad in that period; their
    sign-ups and pickups count within {{ report.attributionWindowDays }} days. On WhatsApp a lead is a first message, on the
    website it's a verified sign-in, so compare the two CTAs on cost per sign-up, CAC and ROAS rather than cost per lead.
  </p>
</div>
